const resources = {
    chatSectionTitle: 'Des questions sur cet essentiel? Clavardons!',
    chatSectionSubtitle: 'Obtenez des réponses et des conseils d’experts de la part de nos conseillers ou conseillères beauté.'
};

module.exports = function getResource(label) {
    return resources[label];
};
